import BaggageIcon from 'components/Icons/BaggageIcon';
import Loader from 'components/Loader';
import { useHistoryBatch } from 'contexts/HistoryBatch';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const HistoryBatchEmpty = () => {
  const navigate = useNavigate();

  const { t } = useTranslation(['history', 'beneficiaries']);

  const { isEmpty, loading, isEmptyFilter, tab } = useHistoryBatch();

  const isDeactivate = useMemo(() => tab === '_DS', [tab]);

  const redirectToCreateBatch = () => {
    if (isDeactivate) {
      navigate('?m=dropdown-modal-deactivate');
      return;
    }

    navigate('?m=dropdown-modal-include');
  };

  if (loading) return <Loader />;

  if (!isEmpty) return null;

  return (
    <div className="empty-history">
      <BaggageIcon />
      <span>{isEmptyFilter ? t('no_file_found') : t('start_register')}</span>
      <span>{isEmptyFilter ? `${t('try_again_files')} \n` : t('start_register_text')}</span>
      {!isEmptyFilter && (
        <button type="button" className="reimport-button" onClick={redirectToCreateBatch}>
          {t('register_button')}
        </button>
      )}
    </div>
  );
};
